import React from "react";
import CommunityViewPage from "../community/components/CommunityViewPage";
import { IMMEDIATE_HELP } from "../community/constants";

export default function ViewImmediateHelpPage() {
  return <CommunityViewPage section={IMMEDIATE_HELP} />;
}
